import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import { MdCheckBox } from "@react-icons/all-files/md/MdCheckBox";
import { MdCheckBoxOutlineBlank } from "@react-icons/all-files/md/MdCheckBoxOutlineBlank";
import { IconContext } from "@react-icons/all-files";
import Background from "../Images/cardDesign.png";
import "./statusCard.css";

export const StatusCard = ({
    isIndividualAssessment,
    positionTitle,
    reqId,
    positionNumber,
    payRate,
    closingDate,
    department,
    workDays,
    workHours,
    sensitive,
    nonSensitive,
    employmentType
}) => {
    return (
        <>
            <Container aria-hidden="true" className="border-shadow rounded-4 mb-1">
                <Row
                    className="rounded-4"
                    style={{
                        backgroundImage: `url(${Background})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover"
                    }}
                >
                    <Col className="pt-3">
                        <Row>
                            <Col>
                                <h4 className="pb-2 border-bottom border-5 border-warning job-font">
                                    {positionTitle}
                                </h4>
                            </Col>
                        </Row>
                        {reqId && !isIndividualAssessment && (
                            <Row>
                                <Col className="">
                                    <Row>
                                        <Col xs={12} md={6} className="">
                                            <h5 className="">Requisition ID:</h5>
                                        </Col>

                                        <Col xs={12} md={6} className="label-font">
                                            <p>{reqId}</p>
                                        </Col>
                                    </Row>
                                    <Row className="pb-2 border-bottom border-2" />
                                </Col>
                            </Row>
                        )}
                        {reqId && isIndividualAssessment && (
                            <Row>
                                <Col className="">
                                    <Row>
                                        <Col xs={12} md={6} className="">
                                            <h5 className="">Individual Assessment ID:</h5>
                                        </Col>

                                        <Col xs={12} md={6} className="label-font">
                                            <p>{reqId}</p>
                                        </Col>
                                    </Row>
                                    <Row className="pb-2 border-bottom border-2" />
                                </Col>
                            </Row>
                        )}
                        <Row>
                            <Col className="pt-2">
                                <Row>
                                    <Col xs={12} md={6} className="">
                                        <h5 className="">Position Number:</h5>
                                    </Col>
                                    <Col xs={12} md={6} className="label-font">
                                        <p>{positionNumber}</p>
                                    </Col>
                                </Row>
                                <Row className="pb-2 border-bottom border-2" />
                            </Col>
                        </Row>
                        
                        
                        {reqId && !isIndividualAssessment && (
                            <Row>
                                <Col className="pt-2">
                                    <Row>
                                        <Col xs={12} md={6} className="">
                                            <h5 className="">Pay Rate:</h5>
                                        </Col>
                                        <Col xs={12} md={6} className="label-font">
                                            <p>{payRate}</p>
                                        </Col>
                                    </Row>
                                    <Row className="pb-2 border-bottom border-2" />
                                </Col>
                            </Row>)
                        }
                        

                        {reqId && !isIndividualAssessment && (
                            <Row>
                                <Col className="pt-2">
                                    <Row>
                                        <Col xs={12} md={6} className="">
                                            <h5 className="">Closing Date:</h5>
                                        </Col>
                                        <Col xs={12} md={6} className="label-font">
                                            <p className="dynamic-font-color">
                                                {closingDate}
                                            </p>
                                        </Col>
                                    </Row>
                                    <Row className="pb-2 border-bottom border-2" />
                                </Col>
                            </Row>)
                        }

                        
                        <Row>
                            <Col className="pt-2">
                                <Row>
                                    <Col xs={12} md={6} className="">
                                        <h5 className="">
                                            Department/Worksite:
                                        </h5>
                                    </Col>
                                    <Col xs={12} md={6} className="label-font">
                                        <p>{department}</p>
                                    </Col>
                                </Row>
                                <Row className="pb-2 border-bottom border-2" />
                            </Col>
                        </Row>
                        
                        {reqId && !isIndividualAssessment && (
                            <Row>
                                <Col className="pt-2">
                                    <Row>
                                        <Col xs={12} md={6}>
                                            <h5 className="">Work Days:</h5>
                                        </Col>
                                        <Col xs={12} md={6} className="label-font">
                                            <p>{workDays}</p>
                                        </Col>
                                    </Row>
                                    <Row className="pb-2 border-bottom border-2" />
                                </Col>
                            </Row>
                        )}
                        
                        {reqId && !isIndividualAssessment && (
                            <Row>
                                <Col className="pt-2">
                                    <Row>
                                        <Col xs={12} md={6} className="">
                                            <h5 className="">Employment Type:</h5>
                                        </Col>
                                        <Col xs={12} md={6} className="label-font">
                                            <p>{employmentType}</p>
                                        </Col>
                                    </Row>
                                    <Row className="pb-2 border-bottom border-2" />
                                </Col>
                            </Row>
                        )} 
                        

                        {reqId && !isIndividualAssessment && (
                            <Row>
                                <Col className="pt-2">
                                    <Row>
                                        <Col xs={12} md={6} className="">
                                            <h5 className="">Work Hours:</h5>
                                        </Col>
                                        <Col xs={12} md={6} className="label-font">
                                            <p>{workHours}</p>
                                        </Col>
                                    </Row>
                                    <Row className="pb-2 border-bottom border-2" />
                                </Col>
                            </Row>
                        )} 
                        

                        <Row>
                            <Col className="pt-2">
                                <Row>
                                    <Col className="">
                                        <h5 className="">Sensitive</h5>
                                    </Col>
                                    <Col className="py-1 px-1">
                                        {sensitive ? (
                                            <IconContext.Provider
                                                value={{
                                                    className: "checkBox"
                                                }}
                                            >
                                                <MdCheckBox />
                                            </IconContext.Provider>
                                        ) : (
                                            <IconContext.Provider
                                                value={{
                                                    className: "checkBox"
                                                }}
                                            >
                                                <MdCheckBoxOutlineBlank />
                                            </IconContext.Provider>
                                        )}
                                    </Col>
                                </Row>
                                <Row className="pb-2 border-bottom border-2" />
                            </Col>
                        </Row>

                        <Row className="mb-2">
                            <Col className="pt-2">
                                <Row>
                                    <Col className="">
                                        <h5 className="">Non-Sensitive</h5>
                                    </Col>
                                    <Col className="py-1 px-1">
                                        {nonSensitive ? (
                                            <IconContext.Provider
                                                value={{
                                                    className: "checkBox"
                                                }}
                                            >
                                                <MdCheckBox />
                                            </IconContext.Provider>
                                        ) : (
                                            <IconContext.Provider
                                                value={{
                                                    className: "checkBox"
                                                }}
                                            >
                                                <MdCheckBoxOutlineBlank />
                                            </IconContext.Provider>
                                        )}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
    );
};
